module.exports = __webpack_public_path__ + "static/media/cy-lab-vote.da3c61dc.png";